<template>
  <div
    :class="placeholderClasses"
    @click="handlePlaceholderClick"
  >
    <div class="config-image__inner-container">
      <div class="config-image__select-next">
        <img
          v-if="isNextSelection"
          :src="nextSelectionPlaceholderImg"
          class="responsive-img"
          alt="Selection placeholder"
        >
        <img
          v-if="!isNextSelection"
          :src="placeholderImg"
          class="responsive-img"
          alt="Image placeholder"
        >
      </div>
    </div>
  </div>
</template>

<script>
import nextSelectionPlaceholderImg from '../../../img/selection-placeholder.png'
import placeholderImg from '../../../img/placeholder.png'

export default {
  name: 'PhotoSelectionSlotPlaceholder',
  props: {
    isNextSelection: { type: Boolean, default: false, required: true }
  },
  data () {
    return {
      nextSelectionPlaceholderImg,
      placeholderImg
    }
  },
  computed: {
    placeholderClasses () {
      return {
        'config-image__container': true,
        'config-image__container--alt-gradimages': true,
        'photoset__select-photo': this.isNextSelection
      }
    }
  },
  methods: {
    handlePlaceholderClick () {
      if (this.isNextSelection === true) {
        this.$emit('select-photo-clicked')
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-mix/components/PhotoSelection/Slot/Placeholder.vue